import VoiceConfiguration from 'models/voice_configuration';

export default class UpdateVoiceConfiguration {
  constructor(context) {
    this.context = context;
  }

  run({ callWrapUpIntervalSecs, declineCallAutoReadyIntervalSecs }) {
    this.context.stores.voiceConfiguration.setPending(
      VoiceConfiguration.create({ callWrapUpIntervalSecs, declineCallAutoReadyIntervalSecs })
    );
    this.context.gateways.voiceConfiguration.update({ callWrapUpIntervalSecs, declineCallAutoReadyIntervalSecs });
  }
}



// WEBPACK FOOTER //
// ./src/scripts/application/actions/endpoint/update_voice_configuration.js